<template>
  <div class="app-shell">
    <header class="site-header">
      <router-link to="/" class="brand" aria-label="shuffles.88 home"><span class="brand-mark">s.</span><span>shuffles<span class="brand-dot">.88</span></span></router-link>
      <button class="mobile-menu" @click="menuOpen = !menuOpen" aria-label="Toggle navigation">☰</button>
      <nav :class="['main-nav', { 'nav-open': menuOpen }]">
        <router-link to="/games" @click="menuOpen = false">Explore games</router-link>
        <a href="/#how-it-works" @click="menuOpen = false">How it works</a>
        <template v-if="auth.isLoggedIn">
          <router-link :to="auth.isAdmin ? '/admin' : '/account'" @click="menuOpen = false">{{ auth.isAdmin ? 'Admin studio' : 'My bookings' }}</router-link>
          <button class="nav-login" @click="signOut">Log out</button>
        </template>
        <template v-else><router-link to="/login" @click="menuOpen = false">Log in</router-link><router-link class="nav-cta" to="/register" @click="menuOpen = false">Join the crew <span>↗</span></router-link></template>
      </nav>
    </header>
    <main><router-view /></main>
    <footer class="site-footer"><div class="footer-top"><router-link to="/" class="brand"><span class="brand-mark">s.</span><span>shuffles<span class="brand-dot">.88</span></span></router-link><p>Your people. Your games. Your weekend.</p><router-link to="/games" class="text-link">Find your next game ↗</router-link></div><div class="footer-bottom"><span>© {{ currentYear }} shuffles.88</span><span>Made for good times in Port Harcourt.</span></div></footer>
  </div>
</template>
<script>
import { useAuthStore } from './stores/auth'
export default { data: () => ({ menuOpen: false }), computed: { auth() { return useAuthStore() }, currentYear() { return new Date().getFullYear() } }, methods: { async signOut() { await this.auth.logout(); this.menuOpen = false; this.$router.push('/') } } }
</script>
